import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MOMENT_DATEPICKER_PROVIDERS,
  NgDialogModule,
  PageFooterComponent,
} from '@principle-theorem/ng-shared';
import {
  AutomationContext,
  IAutomationConfiguration,
  TemplateScope,
  type IGeneratedTask,
  type IPractice,
  type IStaffer,
  type ITeam,
} from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  type INamedDocument,
  type Timestamp,
} from '@principle-theorem/shared';
import { GeneratedTaskEditComponent } from '../generated-task-edit/generated-task-edit.component';

export interface IGeneratedTaskDialogData {
  task?: IGeneratedTask;
  useRelativeTime: boolean;
  triggerDate?: Timestamp;
  practices?: INamedDocument<IPractice>[];
  configRef?: DocumentReference<IAutomationConfiguration>;
  context: AutomationContext;
}

export interface IGeneratedTaskReturnData extends IGeneratedTask {
  assignee: INamedDocument<IStaffer | ITeam>;
  triggerDate?: Timestamp;
}

@Component({
  selector: 'pr-generated-task-dialog',
  templateUrl: './generated-task-dialog.component.html',
  styleUrls: ['./generated-task-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, GeneratedTaskEditComponent, PageFooterComponent],
  providers: [...MOMENT_DATEPICKER_PROVIDERS],
})
export class GeneratedTaskDialogComponent {
  appointmentScope = TemplateScope.Appointment;

  constructor(
    private _dialogRef: MatDialogRef<
      GeneratedTaskDialogComponent,
      IGeneratedTaskReturnData
    >,
    @Inject(MAT_DIALOG_DATA) public data?: IGeneratedTaskDialogData
  ) {}

  save(form: GeneratedTaskEditComponent): void {
    const task = form.submit();
    if (!task) {
      return;
    }
    this._dialogRef.close(task);
  }
}
